import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  step: 'Paso 1',
  title: 'Cómo elegir una idea de negocio rentable',
  description: 'Aprendé a identificar oportunidades reales en internet y elegir una idea con potencial de venta.'
}, {
  step: 'Paso 2',
  title: 'Cómo transformar tu conocimiento en un producto o servicio',
  description: 'Descubrí cómo convertir lo que sabés en algo que otras personas estén dispuestas a pagar.'
}, {
  step: 'Paso 3',
  title: 'Cómo empezar a vender por internet',
  description: 'Las herramientas y plataformas que podés usar para lanzar tu negocio digital.'
}, {
  step: 'Paso 4',
  title: 'Cómo conseguir tus primeros clientes',
  description: 'Estrategias simples para empezar a generar ventas online.'
}, {
  step: 'Paso 5',
  title: 'Cómo escalar tu negocio digital',
  description: 'Cómo transformar ingresos extra en un negocio online estable.'
}];
export function WhatYouLearnSection() {
  return <section className="py-20 bg-white" data-id="element-108">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-slate-900 mb-4" data-id="element-111">
            Qué vas a aprender en Emprende Digital
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-112">
            Dentro de esta guía vas a descubrir paso a paso cómo crear tu propio
            negocio online.
          </motion.p>
        </div>

        <div className="space-y-6" data-id="element-113">
          {steps.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 border border-slate-100 hover:shadow-md transition-shadow" data-id="element-114">
              <div className="flex-shrink-0 bg-brand-blue text-white font-heading font-bold text-lg px-6 py-3 rounded-xl shadow-sm" data-id="element-115">
                {item.step}
              </div>
              <div data-id="element-116">
                <h3 className="text-xl font-heading font-bold text-slate-900 mb-2" data-id="element-117">
                  {item.title}
                </h3>
                <p className="text-slate-600 text-lg" data-id="element-118">{item.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}